import React from 'react'

const Foooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="bg-gray-200 text-center py-1 sm:py-2 px-2 sm:px-4 w-full">
      <p className="text-[8px] sm:text-[10px] md:text-xs lg:text-sm text-gray-500">&copy; Copyright {currentYear} The Beauty School Group LLC. All Rights Reserved.</p>
    </div>
  );
}

export default Foooter